export enum NettingEngineSummary {
    NO = 'Close out netting is not enforceable',
    MAYBE = 'Close out netting might be enforceable',
    YES = 'Close out netting is enforceable',
    YES_PRODUCTS_UNKNOWN = 'Close out netting is enforceable depending on selected transaction types'
}
